import HeroImg from '../../img/heroImg.png'

const StaticsImages = () => {
  return (
    <div className="w-full h-full absolute flex items-center justify-center top-6 left-0 lg:px-30 lg:py-4 gap-4 flex-wrap ">
      <div>
        <img src={HeroImg} alt="Varag Vardan phone" />
      </div>
    </div>
  );
};

export default StaticsImages;
